<template>
  <el-container class="InvoiceForm">
    <el-main>
      <el-form
        ref="form"
        label-width="80px"
        :model="data"
        :rules="rules"
        :inline="false"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="발행일" prop="issue_date">
              <ADatePicker v-model="data.issue_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="금액" prop="price">
              <ANumberInput v-model="data.price" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="발행번호" prop="approval_number">
              <el-input v-model="data.approval_number" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <ATable
        ref="table"
        :data="details"
        :height="200"
        hideButtonExcel
        hide-button-insert
        hide-pagination
      >
        <el-table-column
          prop="sale_date"
          label="매출일자"
          :width="$width.date"
        />
        <el-table-column
          prop="product_name"
          label="품목"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          :width="$width.size"
        />

        <el-table-column
          prop="amount"
          label="수량"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column prop="desc" label="비고" show-overflow-tooltip />
        <el-table-column label="삭제" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index)"
              >삭제</el-button
            >
          </template>
        </el-table-column>
      </ATable>

      <el-dialog
        custom-class="form-dialog"
        top="0"
        title="매출 가져오기"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
        destroyOnClose
      >
        <SaleSelect
          ref="inner"
          v-if="dialogVisible"
          :customer_id="customer.id"
          :currentItems="details"
          :type="2"
          @selceted="handleSelected"
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        @shortkey.native="clickSave"
        @click="clickSave"
        >{{ data.id > 0 ? "수정" : "등록" }} (F4)</el-button
      >
      <el-button @click="handleClickLoadSale">매출 가져오기</el-button>
      <el-button v-if="data.id > 1" type="danger" @click="clickDelete"
        >삭제</el-button
      >

      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import SaleSelect from "./SaleSelect";

export default {
  name: "InvoiceForm",
  mixins: [form],
  components: { SaleSelect },
  data() {
    const validateValue = (rule, value, callback) => {
      let unpublished_price = this.customer.unpublished_price
        ? this.customer.unpublished_price
        : 0;

      if (this.isNew) {
        if (value > unpublished_price) {
          callback("세금계산서 미 발행금액을 초과");
        }
      } else {
        if (value > unpublished_price + this.data.price_old) {
          callback("세금계산서 미 발행금액을 초과2");
        }
      }

      if (value > 2147483647) {
        callback("금액 최대값은 2147483647 입니다.");
      } else if (value < 1) {
        callback("금액은 0 보다 커야 합니다.");
      } else {
        callback();
      }
    };
    return {
      title: this.$t("title.invoice"),
      rules: {
        issue_date: [{ required: true, message: "발행일을 입력해 주세요." }],
        price: [
          { required: true, message: "금액을 입력해 주세요." },
          { validator: validateValue },
        ],
        // approval_number: [{required: true, message: '발행번호를 입력하세요.'}],
      },
      originData: null,
      dialogVisible: false,
      details: [],
    };
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: function() {
        return {
          id: null,
          customer_id: 0,
          issue_date: this.util.getDateString(),
          approval_number: "",
          supply_price: 0,
          tax: 0,
          price: 0,
        };
      },
    },
  },
  mounted() {
    if (this.data.id) {
      this.loadSale();
    }
  },
  computed: {
    isNew: function() {
      return !this.data.id;
    },
  },
  methods: {
    loadSale() {
      this.api.listSaleInvoice(this.data.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.details = res.data;
      });
    },
    /** 저장 */
    clickSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;

        if (this.data.id > 0) {
          this.doUpdate();
        } else {
          this.doCreate();
        }
      });
    },

    /** 삭제 */
    clickDelete() {
      if (this.data.id < 1) {
        this.util.notify(this, "w", this.title, "저장된 데이타가 아닙니다.");
        return;
      }

      /** 삭제 */
      this.util.confirm_delete(this, this.title, this.doDelete);
    },

    doCreate() {
      this.data.customer_id = this.customer.id;
      this.data.details = this.details;
      this.api.createInvoice(this.data).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
        } else {
          this.handleResult(res, "create", "등록되었습니다.");
        }
      });
    },

    doUpdate() {
      this.data.customer_id = this.customer.id;
      this.data.details = this.details;
      this.api.updateInvoice(this.data).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
        } else {
          this.handleResult(res, "update", "수정되었습니다.");
        }
      });
    },

    doDelete() {
      this.api.deleteInvoice(this.data).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
        } else {
          this.handleResult(res, "delete", "삭제되었습니다.");
        }
      });
    },

    /** noti 옵션 반환 */
    getNotifyOptions(message) {
      return this.util.get_notify_options("s", this.title, message);
    },
    appendItem(selection) {
      selection.forEach((item) => {
        let exist = this.details.find((d) => d.id === item.id);
        if (!exist) {
          this.details.push(item);
        }
      });
      this.setSummaryTotalPrice();
    },
    setSummaryTotalPrice() {
      let totalSupplyPrice = 0;
      let totalTax = 0;
      let totalPrice = 0;
      this.details.forEach((item) => {
        totalSupplyPrice += item.supply_price;
        totalTax += item.tax;
        totalPrice += item.price;
      });
      this.data.supply_price = totalSupplyPrice;
      this.data.tax = totalTax;
      this.data.price = totalPrice;
    },
    handleResult(res, action, message) {
      if (res.error === this.system.noError) {
        const options = this.getNotifyOptions(message);
        this.$emit("completed", action, options);
        return;
      }
      this.util.notify_error(this, this.$t("title.invoice"), res.message);
    },
    handleClickLoadSale() {
      this.dialogVisible = true;
    },
    handleSelected(selection) {
      this.appendItem(selection);
      this.dialogVisible = false;
    },
    handleDelete(index /*, row*/) {
      this.details.splice(index, 1);
      this.setSummaryTotalPrice();
    },
  },
};
</script>
